const PageWrapper = (props: { children: any }) => {
  return <div className="page-wrapper">{props.children}</div>;
};

export default PageWrapper;
